import { render, staticRenderFns } from "./header_new.vue?vue&type=template&id=6fb9eac0&scoped=true"
import script from "./header_new.vue?vue&type=script&lang=js"
export * from "./header_new.vue?vue&type=script&lang=js"
import style0 from "./header_new.vue?vue&type=style&index=0&id=6fb9eac0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb9eac0",
  null
  
)

export default component.exports